import React, { useState, useEffect } from 'react';
// Script Path & Filename: frontend/src/components/UIConfigModal.jsx

export const UIConfigModal = ({ token, schema, table, onClose, onSuccess }) => {
    const [columns, setColumns] = useState([]);
    const [displayCol, setDisplayCol] = useState('');
    const [iconName, setIconName] = useState('table_view');
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        fetch(`/api/data/schema/columns/${schema}/${table}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
        .then(r => r.json())
        .then(data => {
            setColumns(data);
            if (data.length > 0) setDisplayCol(data[0].name);
        });
    }, [schema, table, token]);

    const submit = async (e) => {
        e.preventDefault();
        setSaving(true);
        try {
            const res = await fetch('/api/data/uiconfig', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify({
                    TargetSchema: schema,
                    TargetTable: table,
                    DisplayColumn: displayCol,
                    MaterialSymbolName: iconName
                })
            });
            if (res.ok) {
                onSuccess();
            } else {
                console.error('Failed to save config');
                setSaving(false);
            }
        } catch (err) {
            console.error(err);
            setSaving(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
            <div className="bg-slate-800 p-6 rounded-lg border border-slate-700 w-96 shadow-2xl">
                <h3 className="text-xl font-bold text-blue-400 mb-2">Define Relationship UI</h3>
                <p className="text-sm text-slate-400 mb-6">Missing display mapping for <strong>{schema}.{table}</strong>.</p>
                
                <form onSubmit={submit} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-slate-300 mb-1">Display Column</label>
                        <select value={displayCol} onChange={e => setDisplayCol(e.target.value)} required
                            className="w-full bg-slate-900 border border-slate-600 rounded px-3 py-2 text-white outline-none focus:border-blue-500 transition-colors">
                            {columns.map(c => <option key={c.name} value={c.name}>{c.name}</option>)}
                        </select>
                        <p className="text-xs text-slate-500 mt-1">Shown when another table links to this one.</p>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-slate-300 mb-1">Material Symbol Name</label>
                        <input type="text" value={iconName} onChange={e => setIconName(e.target.value)} required
                            className="w-full bg-slate-900 border border-slate-600 rounded px-3 py-2 text-white outline-none focus:border-blue-500 transition-colors" />
                    </div>
                    <div className="flex justify-end space-x-3 mt-6">
                        <button type="button" onClick={onClose} disabled={saving}
                            className="px-4 py-2 text-sm text-slate-400 hover:text-white transition-colors">Cancel</button>
                        <button type="submit" disabled={saving}
                            className="px-4 py-2 text-sm bg-blue-600 hover:bg-blue-500 text-white rounded transition-colors">
                            {saving ? 'Saving...' : 'Save Configuration'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};